import Layout from 'components/Layout/Layout';
import PageMeta from 'components/PageMeta';
import { Result } from 'components/Search/Result';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import { getCommonServerSideProps } from 'server/getCommonServerSideProps';

export default function Page() {
    const router = useRouter();
    const { query } = router;
    const searchValue = query.query ?? '';
    const { t } = useServerTranslation();

    return (
        <Layout>
            <PageMeta
                title={t('seo.title.search', { searchQuery: searchValue })}
                description={t('seo.description.search', { description: searchValue })}
            />
            <Result searchValue={Array.isArray(searchValue) ? searchValue.join(' ') : searchValue} />
        </Layout>
    );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
    return getCommonServerSideProps({ context });
}
